import { render, staticRenderFns } from "./TableRowVialsTotal.vue?vue&type=template&id=4f4684ad&lang=pug&"
import script from "./TableRowVialsTotal.vue?vue&type=script&lang=js&"
export * from "./TableRowVialsTotal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/workspace/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4f4684ad')) {
      api.createRecord('4f4684ad', component.options)
    } else {
      api.reload('4f4684ad', component.options)
    }
    module.hot.accept("./TableRowVialsTotal.vue?vue&type=template&id=4f4684ad&lang=pug&", function () {
      api.rerender('4f4684ad', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "public/js/src/app/components/allergy-kpis/tracking-sheet/table-rows/TableRowVialsTotal.vue"
export default component.exports